// ============================================================
// PREZENCE — Local business date (frontend)
//
// WHY: `new Date().toISOString().split('T')[0]` is the UTC date.
// In Bangladesh (UTC+6) that is yesterday's date for the whole
// period between midnight and 6 AM local — so date pickers and
// "today" filters silently pointed at the wrong day, and records
// looked missing even though they were saved correctly.
//
// The backend stores dates using company-local time, so the UI has
// to agree. `en-CA` locale formats as YYYY-MM-DD, which is exactly
// the shape the API expects.
// ============================================================

/** Today's date in the user's local timezone, as YYYY-MM-DD. */
export function todayLocal() {
  return new Date().toLocaleDateString('en-CA');
}

/** Any Date as a local YYYY-MM-DD string. */
export function toLocalDate(date) {
  return new Date(date).toLocaleDateString('en-CA');
}
